import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";


type TaskResponse = ResponseType<{
  range: number[]
  country: string
  region: string
  eu: string
  timezone: string
  city: string
  ll: number[]
  metro: number
  area: number
}
>;

function useCurruntLocationQuary() {
  return useQuery<
    AxiosResponseAndError<TaskResponse>["response"],
    AxiosResponseAndError<TaskResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.getLocation],
    queryFn: async () =>await ApiRequest.get(requestURLs.ip),
    enabled:true,
  });
}

export default useCurruntLocationQuary;
